import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";
import { Link, Stack, Typography } from "@mui/material";

import { encampBrandColors } from "../../../../colors";
import { SCOUT_SUPPORT_ARTICLE } from "../ScoutInfoPanel";

/**
 * Footer CTA on the Scout empty state for Regulatory Advisor tenants.
 * Links to the Scout support article (same destination as other Scout Pro
 * "Learn more" CTAs after the marketing landing page was deferred).
 */
export function ScoutProFooterUpsell() {
  return (
    <Stack
      component={Link}
      href={SCOUT_SUPPORT_ARTICLE}
      target="_blank"
      rel="noopener noreferrer"
      direction="row"
      spacing={0.75}
      alignItems="center"
      justifyContent="center"
      sx={{
        flexShrink: 0,
        // 36px below the link so it reads clearly off the page edge.
        pb: 4.5,
        px: 2,
        textDecoration: "none",
        color: encampBrandColors.pumpkin,
        "&:hover": {
          textDecoration: "underline",
        },
      }}
      aria-label="Learn more about Scout Pro"
    >
      <LightbulbOutlined sx={{ fontSize: 20 }} />
      <Typography
        variant="body1"
        sx={{
          color: "inherit",
          fontWeight: 400,
          letterSpacing: "0.15px",
          fontFeatureSettings: "'liga' off, 'clig' off",
        }}
      >
        Unlock personalized, facility-specific help with Scout Pro
      </Typography>
    </Stack>
  );
}
